import React from "react";

const ICON_SEARCH = "/icons/appointments/dashboard/search.svg";
const ICON_CANCEL = "/icons/pharmacy/circle-x.svg";

function TuneIcon({ className = "" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="4" y1="6" x2="14" y2="6" />
      <line x1="10" y1="18" x2="20" y2="18" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <circle cx="17" cy="6" r="2" />
      <circle cx="7" cy="18" r="2" />
    </svg>
  );
}

export default function AfrimedSearchBar({
  value,
  onChange,
  onClear,
  placeholder = "Hinted search text",
  className = "",
  inputClassName = "",
  ariaLabel = "Search",
  showTrailing = true,
}) {
  const hasValue = String(value || "").trim().length > 0;

  return (
    <label
      className={[
        "flex h-11 w-full items-center gap-1 rounded-[28px]",
        "border border-[rgba(91,107,134,0.18)] bg-[rgba(86,106,139,0.08)] px-1",
        "transition-colors duration-150 focus-within:border-[rgba(77,163,255,0.28)]",
        className,
      ].join(" ")}
    >
      <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-on-surface-var">
        <img src={ICON_SEARCH} alt="" className="h-5 w-5 opacity-80" draggable="false" />
      </span>

      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className={[
          "afrimed-search-bar__input min-w-0 flex-1 bg-transparent",
          "text-body-large text-on-surface placeholder:text-on-surface-var",
          "focus:outline-none",
          inputClassName,
        ].join(" ")}
      />

      {hasValue ? (
        <button
          type="button"
          onClick={onClear}
          className="inline-flex h-9 w-9 shrink-0 items-center justify-center text-on-surface-var transition hover:text-on-surface"
          aria-label="Clear search"
          title="Clear search"
        >
          <img
            src={ICON_CANCEL}
            alt=""
            aria-hidden="true"
            className="h-[18px] w-[18px] shrink-0 brightness-0 opacity-80 dark:invert"
            draggable="false"
          />
        </button>
      ) : showTrailing ? (
        <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-on-surface-var">
          <TuneIcon className="h-5 w-5 opacity-80" />
        </span>
      ) : null}
    </label>
  );
}
